import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CancelIcon from "@mui/icons-material/Cancel";
import Swal from "sweetalert2";
import moment from "moment";
import axios from "axios";
import Moment from "moment";
import InputMask from "react-input-mask";
import {
  Box,
  Button,
  CircularProgress,
  FormControlLabel,
  FormGroup,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  Tooltip,
  Checkbox,
} from "@mui/material";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { DataGrid } from "@mui/x-data-grid";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SendIcon from "@mui/icons-material/Send";
export default function PatientsQuestionaire({
  patientId,
  Patientinfo,
  OtherPatientInfo,
  FormId,
  handleClose,
  onFormSubmit
}) {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({});

  // patient Info
  const [PatientDate, setPatientDate] = useState(Moment().format("YYYY-MM-DD"));
  const [PatientFirstname, setPatientFullname] = useState(
    Patientinfo.firstName || ""
  );
  const [PatientLastName, setPatientlastName] = useState(Patientinfo.lastName);
  const [PatientGender, setPatientGender] = useState(Patientinfo.gender);
  const [PatientAge, setPatientAge] = useState(OtherPatientInfo.age);
  const [PatientDob, setPatientDob] = useState("");
  useEffect(() => {
    if (Patientinfo?.dob) {
      const formatted = Patientinfo.dob.replaceAll("/", "-").split("T")[0];
      setPatientDob(formatted);
    }
  }, [Patientinfo]);

  const [PatientemailAddress, setPatientemailAddress] = useState(
    Patientinfo.emailAddress || ""
  );
  const [PatientcellPhone, setPatientcellPhone] = useState(
    Patientinfo.cellPhone || ""
  );
  const [Patientaddress, setPatientaddress] = useState(
    Patientinfo.address || ""
  );


  const [InsuranceplanName, setInsuranceplanName] = useState();
  const [InsurancememberId, setInsurancememberId] = useState();
  const [InsurancegroupId, setInsurancegroupId] = useState(
    Patientinfo?.priIns?.groupId || ""
  );
  const [InsurancesubsRelation, setInsurancesubsRelation] = useState(
    Patientinfo?.priIns?.subsRelation || ""
  );
  const [SecInsuranceplanName, setSecInsuranceplanName] = useState();
  const [PolicyHolderName, setPolicyHolderName] = useState("");
  const [PolicyHolderDOB, setPolicyHolderDOB] = useState("");
  const [InsurancePhone, setInsurancePhone] = useState("");
  useEffect(() => {
    if (Patientinfo) {
      setInsuranceplanName(Patientinfo?.priIns?.planName ?? "");
      setSecInsuranceplanName(Patientinfo?.secIns?.planName ?? "");
      setInsurancememberId(Patientinfo?.priIns?.memberId ?? "");
    }
  }, [Patientinfo]);
  useEffect(() => {
    if (InsurancesubsRelation === "Self" && Patientinfo) {
      setPolicyHolderName(
        `${Patientinfo?.firstName || ""} ${Patientinfo?.lastName || ""}`
      );
      setInsurancePhone(Patientinfo?.cellPhone);
      setSecInsuranceplanName(Patientinfo?.secIns?.planName);
      setPolicyHolderDOB(
        Patientinfo?.dob ? Moment(Patientinfo?.dob).format("YYYY-MM-DD") : ""
      );
    }
  }, [InsurancesubsRelation, Patientinfo]);
  const handleInsuranceChange = (e) => {
    const { name, value } = e.target;

    switch (name) {
      case "primaryInsuranceCarrier":
        setInsuranceplanName(value);
        break;
      case "policyNumber":
        setInsurancememberId(value);
        break;
      case "groupNumber":
        setInsurancegroupId(value);
        break;
      case "relationshipToPatient":
        setInsurancesubsRelation(value);
        break;
      case "secondaryInsurance":
        setSecInsuranceplanName(value);
        break;
      case "policyHolderName":
        setPolicyHolderName(value);
        break;
      case "policyHolderDOB":
        setPolicyHolderDOB(value);
        break;
      case "insurancePhone":
        setInsurancePhone(value);
        break;
      default:
        break;
    }
  };

  const [loading, setLoading] = useState(false);
  const [patientquestionairId, setPatientQuestionairId] = useState(0);
  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = {
    Authorization: auth,
  };

  // Calculate age from DOB
  const calculateAge = (dob) => {
    if (!dob) return { display: "", value: null };
    const years = moment().diff(moment(dob), "years");
    const months = moment().diff(moment(dob).add(years, "years"), "months");
    const days = moment().diff(
      moment(dob).add(years, "years").add(months, "months"),
      "days"
    );
    const display = `${years}Y ${months}M ${days}D`;
    return { display, value: years };
  };

  // Initialize form data
  const initializeFormData = () => {
    const dob = Patientinfo?.dOB
      ? moment(Patientinfo.dOB).format("YYYY-MM-DD")
      : "";
    const ageData = dob ? calculateAge(dob) : { display: "", value: null };
    return {
      patientId: Number(patientId) || 0,
      id: 0,
      dateCreated: new Date().toISOString(),
      date: Moment().format("YYYY-MM-DD"),
      createdBy: localStorage.getItem("email") || "",
      fullName: "",
      dob,
      age: ageData.display || "",
      ageValue: ageData.value || null,
      phone: "",
      email: "",
      gender: "",
      otherGender: "",
      address: "",
      emergencyContact: "",
      primaryInsuranceCarrier: "",
      policyNumber: "",
      groupNumber: "",
      policyHolderName: "",
      policyHolderDOB: "",
      relationshipToPatient: "",
      otherRelationship: "",
      insurancePhone: "",
      secondaryInsurance: "",
      tobaccoUse: "",
      alcoholUse: "",
      alcoholUseDetails: "",
      recreationalDrugUse: "",
      occupation: "",
      maritalStatus: "",
      reasonForVisit: "",
      otherDisease: "",
      pastsurgries: "",
      hospitalization: "",
      pastMedication: "",
      signature: "",
      hospitalizations: "",
      medications: "",
      pastSurgeries: "",
      otherMedicalCondition: "",
      diabetes: "",
      highBloodPressure: "",
      heartDisease: "",
      asthmaCOPD: "",
      kidneyDisease: "",
      liverDisease: "",
      cancer: "",
      cancerType: "",
      sleepApnea: "",
      depressionAnxiety: "",
      noKnownAllergies: "",
      medicationAllergies: "",
      medicationAllergiesText: "",
      foodAllergies: "",
      foodAllergiesText: "",
      otherAllergies: "",
      otherAllergiesText: "",
      familyHeartDisease: "",
      familyHeartDiseaseRelation: "",
      familyHighBloodPressure: "",
      familyHighBPRelation: "",
      familyStroke: "",
      familyStrokeRelation: "",
      familyDiabetes: "",
      familyDiabetesRelation: "",
      familyCancer: "",
      familyCancerRelation: "",
      familyCancerType: "",
      familyOtherHistory: "",
      familyOtherRelation: "",
      fatigue: "",
      chestPain: "",
      shortnessOfBreath: "",
      frequentUrination: "",
      visionChanges: "",
      hearingProblems: "",
      abdominalPain: "",
      jointPain: "",
      skinRashes: "",
      headaches: "",
      troubleSleeping: "",
      anxietyDepression: "",
      otherSymptoms: "",
      otherSymptomsText: "",
    };
  };

  // Input handler for text fields
  // 🔹 TEXT FIELDS + NORMAL INPUTS
  const handleChange = (e) => {
    const { name, value } = e.target;

    // Prevent changes to read-only fields
    if (["fullName", "dob", "age"].includes(name)) return;

    setFormData((prev) => {
      const updated = { ...prev, [name]: value };

      // Reset dependent fields
      if (name === "gender" && value !== "Other") updated.otherGender = "";
      if (name === "relationshipToPatient" && value !== "Other")
        updated.otherRelationship = "";
      if (name === "alcoholUse" && value === "No")
        updated.alcoholUseDetails = "";
      if (name === "cancer" && value !== "Yes") updated.cancerType = "";
      if (name === "medicationAllergies" && value !== "Yes")
        updated.medicationAllergiesText = "";
      if (name === "foodAllergies" && value !== "Yes")
        updated.foodAllergiesText = "";
      if (name === "otherAllergies" && value !== "Yes")
        updated.otherAllergiesText = "";

      if (name === "familyHeartDisease" && value !== "Yes")
        updated.familyHeartDiseaseRelation = "";
      if (name === "familyHighBloodPressure" && value !== "Yes")
        updated.familyHighBPRelation = "";
      if (name === "familyStroke" && value !== "Yes")
        updated.familyStrokeRelation = "";
      if (name === "familyDiabetes" && value !== "Yes")
        updated.familyDiabetesRelation = "";

      if (name === "familyCancer" && value !== "Yes") {
        updated.familyCancerRelation = "";
        updated.familyCancerType = "";
      }

      if (name === "familyOtherHistory" && value !== "Yes")
        updated.familyOtherRelation = "";
      if (name === "otherSymptoms" && value !== "Yes")
        updated.otherSymptomsText = "";

      return updated;
    });
  };

  // 🔹 RADIO BUTTONS WITH TOGGLE ON/OFF
  const handleChangeRadio = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      // IF SAME VALUE CLICKED AGAIN → UNCHECK (RESET)
      if (prev[name] === value) {
        return {
          ...prev,
          [name]: "",
        };
      }

      // Otherwise apply normal logic
      const updated = {
        ...prev,
        [name]: value,
      };

      // Reset linked fields
      if (name === "cancer" && value !== "Yes") updated.cancerType = "";

      return updated;
    });
  };

  const defaultPractice = JSON.parse(localStorage.getItem("default_paractice"));
  console.log(defaultPractice, "defaultPractice");
  // Fetch questionnaire or initialize form
  const [SelectedQuestionare, setSelectedQuestionare] = useState("");

  {
    /*useEffect(() => {
    setFormData(initializeFormData());

    const safePatientId = Number(patientId) || 0;
    if (patientId) {
      setLoading(true);
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/PatientQuestionnaire/getListquestionarebypatientid?id=${patientId}`,
          { headers }
        )
        .then((response) => {
          const res = response[0]
          setPatientQuestionairId(res.id || 0);

          if (res?.date) {
            const onlyDate = res.date.split("T")[0]; // "2025-09-19"
            setPatientDate(onlyDate);
          }
          if (res?.primaryInsuranceCarrier) {
            setInsuranceplanName(res.primaryInsuranceCarrier || "");
          }
          if (res?.policyNumber) {
            setInsurancememberId(res.policyNumber || "");
          }
          if (res?.groupNumber) {
            setInsurancegroupId(res.groupNumber || "");
          }
          if (res?.policyHolderName) {
            setPolicyHolderName(res.policyHolderName || "");
          }
          if (res?.secondaryInsurance) {
            setSecInsuranceplanName(res.secondaryInsurance || "");
          }
          if (res?.policyHolderDOB) {
            setPolicyHolderDOB(
              res.policyHolderDOB
                ? Moment(res.policyHolderDOB).format("YYYY-MM-DD")
                : ""
            );
          }

          if (res?.relationshipToPatient) {
            setInsurancesubsRelation(res.relationshipToPatient || "");
          }
          if (res?.insurancePhone) {
            setInsurancePhone(res.insurancePhone || "");
          }
          const dob = Patientinfo?.dOB
            ? moment(Patientinfo.dOB).format("YYYY-MM-DD")
            : res.dob
            ? moment(res.dob).format("YYYY-MM-DD")
            : "";
          const ageData = dob
            ? calculateAge(dob)
            : { display: "", value: null };
          const fetchedData = {
            ...res,
            patientId: safePatientId,
            diabetes: res.diabetes ? "Yes" : "No",
            highBloodPressure: res.highBloodPressure ? "Yes" : "No",
            heartDisease: res.heartDisease ? "Yes" : "No",
            asthmaCOPD: res.asthmaCOPD ? "Yes" : "No",
            kidneyDisease: res.kidneyDisease ? "Yes" : "No",
            liverDisease: res.liverDisease ? "Yes" : "No",
            cancer: res.cancer ? "Yes" : "No",
            sleepApnea: res.sleepApnea ? "Yes" : "No",
            depressionAnxiety: res.depressionAnxiety ? "Yes" : "No",
            noKnownAllergies: res.noKnownAllergies ? "Yes" : "No",
            medicationAllergies: res.medicationAllergies ? "Yes" : "No",
            foodAllergies: res.foodAllergies ? "Yes" : "No",
            otherAllergies: res.otherAllergies ? "Yes" : "No",
            familyHeartDisease: res.familyHeartDisease ? "Yes" : "No",
            familyHighBloodPressure: res.familyHighBloodPressure ? "Yes" : "No",
            familyStroke: res.familyStroke ? "Yes" : "No",
            familyDiabetes: res.familyDiabetes ? "Yes" : "No",
            familyCancer: res.familyCancer ? "Yes" : "No",
            familyOtherHistory: res.familyOtherHistory ? "Yes" : "No",
            fatigue: res.fatigue ? "Yes" : "No",
            chestPain: res.chestPain ? "Yes" : "No",
            shortnessOfBreath: res.shortnessOfBreath ? "Yes" : "No",
            frequentUrination: res.frequentUrination ? "Yes" : "No",
            visionChanges: res.visionChanges ? "Yes" : "No",
            hearingProblems: res.hearingProblems ? "Yes" : "No",
            abdominalPain: res.abdominalPain ? "Yes" : "No",
            jointPain: res.jointPain ? "Yes" : "No",
            skinRashes: res.skinRashes ? "Yes" : "No",
            headaches: res.headaches ? "Yes" : "No",
            troubleSleeping: res.troubleSleeping ? "Yes" : "No",
            anxietyDepression: res.anxietyDepression ? "Yes" : "No",
            otherSymptoms: res.otherSymptoms ? "Yes" : "No",
            cancerType: res.cancerType || "",
            medicationAllergiesText: res.medicationAllergiesText || "",
            foodAllergiesText: res.foodAllergiesText || "",
            otherAllergiesText: res.otherAllergiesText || "",
            familyHeartDiseaseRelation: res.familyHeartDiseaseRelation || "",
            familyHighBPRelation: res.familyHighBPRelation || "",
            familyStrokeRelation: res.familyStrokeRelation || "",
            familyDiabetesRelation: res.familyDiabetesRelation || "",
            familyCancerRelation: res.familyCancerRelation || "",
            familyCancerType: res.familyCancerType || "",
            familyOtherRelation: res.familyOtherRelation || "",
            otherSymptomsText: res.otherSymptomsText || "",
            date: res.date ? Moment(res.date).format("YYYY-MM-DD") : "",
            // Use Patientinfo for these fields to ensure they are fixed
            // fullName: Patientinfo?.patientName || res.fullName || "",
            dob,
            // age: ageData.display || Patientinfo?.age || res.age || "",
            // ageValue: ageData.value || Patientinfo?.age || res.age || null,
            // gender: res.gender || Patientinfo?.gender || "",
          };
          setFormData(fetchedData);
        })
        .catch((err) => {
          console.error("Fetch error:", err);
          // Swal.fire({
          //   icon: "error",
          //   title: "Error",
          //   text:
          //     "Failed to fetch questionnaire. Showing form with default values.",
          //   showConfirmButton: true,
          // });
        })
        .finally(() => setLoading(false));
    }
  }, [patientId, Patientinfo]);*/
  }
  useEffect(() => {
    setFormData(initializeFormData());
    const safePatientId = Number(patientId) || 0;
    if (FormId) {
      setLoading(true);
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/PatientQuestionnaire/getquestionarebyquestionareid?id=${FormId}`,
          { headers }
        )
        .then((res) => {
          setPatientQuestionairId(res.id || 0);

          if (res?.date) {
            const onlyDate = res.date.split("T")[0]; // "2025-09-19"
            setPatientDate(onlyDate);
          }
          if (res?.primaryInsuranceCarrier) {
            setInsuranceplanName(res.primaryInsuranceCarrier || "");
          }
          if (res?.policyNumber) {
            setInsurancememberId(res.policyNumber || "");
          }
          if (res?.groupNumber) {
            setInsurancegroupId(res.groupNumber || "");
          }
          if (res?.policyHolderName) {
            setPolicyHolderName(res.policyHolderName || "");
          }
          if (res?.secondaryInsurance) {
            setSecInsuranceplanName(res.secondaryInsurance || "");
          }
          if (res?.policyHolderDOB) {
            setPolicyHolderDOB(
              res.policyHolderDOB
                ? Moment(res.policyHolderDOB).format("YYYY-MM-DD")
                : ""
            );
          }

          if (res?.relationshipToPatient) {
            setInsurancesubsRelation(res.relationshipToPatient || "");
          }
          if (res?.insurancePhone) {
            setInsurancePhone(res.insurancePhone || "");
          }
          const dob = Patientinfo?.dOB
            ? moment(Patientinfo.dOB).format("YYYY-MM-DD")
            : res.dob
            ? moment(res.dob).format("YYYY-MM-DD")
            : "";
          const ageData = dob
            ? calculateAge(dob)
            : { display: "", value: null };
          const fetchedData = {
            ...res,
            patientId: safePatientId,
            diabetes: res.diabetes ? "Yes" : "No",
            highBloodPressure: res.highBloodPressure ? "Yes" : "No",
            heartDisease: res.heartDisease ? "Yes" : "No",
            asthmaCOPD: res.asthmaCOPD ? "Yes" : "No",
            kidneyDisease: res.kidneyDisease ? "Yes" : "No",
            liverDisease: res.liverDisease ? "Yes" : "No",
            cancer: res.cancer ? "Yes" : "No",
            sleepApnea: res.sleepApnea ? "Yes" : "No",
            depressionAnxiety: res.depressionAnxiety ? "Yes" : "No",
            noKnownAllergies: res.noKnownAllergies ? "Yes" : "No",
            medicationAllergies: res.medicationAllergies ? "Yes" : "No",
            foodAllergies: res.foodAllergies ? "Yes" : "No",
            otherAllergies: res.otherAllergies ? "Yes" : "No",
            familyHeartDisease: res.familyHeartDisease ? "Yes" : "No",
            familyHighBloodPressure: res.familyHighBloodPressure ? "Yes" : "No",
            familyStroke: res.familyStroke ? "Yes" : "No",
            familyDiabetes: res.familyDiabetes ? "Yes" : "No",
            familyCancer: res.familyCancer ? "Yes" : "No",
            familyOtherHistory: res.familyOtherHistory ? "Yes" : "No",
            fatigue: res.fatigue ? "Yes" : "No",
            chestPain: res.chestPain ? "Yes" : "No",
            shortnessOfBreath: res.shortnessOfBreath ? "Yes" : "No",
            frequentUrination: res.frequentUrination ? "Yes" : "No",
            visionChanges: res.visionChanges ? "Yes" : "No",
            hearingProblems: res.hearingProblems ? "Yes" : "No",
            abdominalPain: res.abdominalPain ? "Yes" : "No",
            jointPain: res.jointPain ? "Yes" : "No",
            skinRashes: res.skinRashes ? "Yes" : "No",
            headaches: res.headaches ? "Yes" : "No",
            troubleSleeping: res.troubleSleeping ? "Yes" : "No",
            anxietyDepression: res.anxietyDepression ? "Yes" : "No",
            otherSymptoms: res.otherSymptoms ? "Yes" : "No",
            cancerType: res.cancerType || "",
            medicationAllergiesText: res.medicationAllergiesText || "",
            foodAllergiesText: res.foodAllergiesText || "",
            otherAllergiesText: res.otherAllergiesText || "",
            familyHeartDiseaseRelation: res.familyHeartDiseaseRelation || "",
            familyHighBPRelation: res.familyHighBPRelation || "",
            familyStrokeRelation: res.familyStrokeRelation || "",
            familyDiabetesRelation: res.familyDiabetesRelation || "",
            familyCancerRelation: res.familyCancerRelation || "",
            familyCancerType: res.familyCancerType || "",
            familyOtherRelation: res.familyOtherRelation || "",
            otherSymptomsText: res.otherSymptomsText || "",
            date: res.date ? Moment(res.date).format("YYYY-MM-DD") : "",
            // Use Patientinfo for these fields to ensure they are fixed
            // fullName: Patientinfo?.patientName || res.fullName || "",
            dob,
            // age: ageData.display || Patientinfo?.age || res.age || "",
            // ageValue: ageData.value || Patientinfo?.age || res.age || null,
            // gender: res.gender || Patientinfo?.gender || "",
          };
          setFormData(fetchedData);
        })
        .catch((err) => {
          console.error("Fetch error:", err);
          // Swal.fire({
          //   icon: "error",
          //   title: "Error",
          //   text:
          //     "Failed to fetch questionnaire. Showing form with default values.",
          //   showConfirmButton: true,
          // });
        })
        .finally(() => setLoading(false));
    }
  }, [FormId]);
  // Submit handler
  const onSubmit = (e) => {
    e.preventDefault();

    const safePatientId = Number(formData.patientId) || 0;
    const practiceId = defaultPractice || 0;

    // Validate critical fields
    if (!safePatientId) {
      Swal.fire({
        icon: "error",
        title: "Invalid Patient ID",
        text: "Please ensure a valid patient ID is provided.",
        showConfirmButton: true,
        willOpen: (popup) => {
          // Popup modal z-index
          popup.style.zIndex = "1800";
          // Overlay container z-index
          const container = document.querySelector(".swal2-container");
          if (container) container.style.zIndex = "1800";
        },
      });
      return;
    }

    if (!practiceId) {
      Swal.fire({
        icon: "error",
        title: "Invalid Practice ID",
        text: "Please ensure a valid practice ID is provided.",
        showConfirmButton: true,
        willOpen: (popup) => {
          // Popup modal z-index
          popup.style.zIndex = "1800";
          // Overlay container z-index
          const container = document.querySelector(".swal2-container");
          if (container) container.style.zIndex = "1800";
        },
      });
      return;
    }

    // Validate required fields
    if (!formData.reasonForVisit) {
      Swal.fire({
        icon: "error",
        title: "Missing Required Field",
        text: "Please provide the reason for today's visit.",
        showConfirmButton: true,
        willOpen: (popup) => {
          // Popup modal z-index
          popup.style.zIndex = "1800";
          // Overlay container z-index
          const container = document.querySelector(".swal2-container");
          if (container) container.style.zIndex = "1800";
        },
      });
      return;
    }

    // Validate date field
    const validDate =
      PatientDate &&
      typeof PatientDate === "string" &&
      moment(PatientDate, "YYYY-MM-DD", true).isValid()
        ? PatientDate
        : Moment().format("YYYY-MM-DD"); // Default to current date if invalid or empty

    setLoading(true);

    const payload = {
      id: patientquestionairId || 0,
      patientId: safePatientId,
      practiceId: practiceId,
      date: validDate, // Use validated date
      dateCreated: formData.dateCreated || new Date().toISOString(),
      createdBy: formData.createdBy || localStorage.getItem("email") || "",
      updatedBy: localStorage.getItem("email") || "",
      inactive: false,
      phone: formData.phone || "",
      email: formData.email || "",
      otherGender:
        formData.gender === "Other" ? formData.otherGender || "" : "",
      address: formData.address || "",
      emergencyContact: formData.emergencyContact || "",
      primaryInsuranceCarrier: InsuranceplanName || "",
      policyNumber: InsurancememberId || "",
      groupNumber: InsurancegroupId || "",
      policyHolderName: PolicyHolderName || "",
      policyHolderDOB: PolicyHolderDOB || "",
      relationshipToPatient: InsurancesubsRelation || "",
      otherRelationship:
        formData.relationshipToPatient === "Other"
          ? formData.otherRelationship || ""
          : "",
      insurancePhone: InsurancePhone || "",
      secondaryInsurance: SecInsuranceplanName || "",
      tobaccoUse: formData.tobaccoUse || "",
      alcoholUse: formData.alcoholUse || "",
      alcoholUseDetails:
        formData.alcoholUse === "Yes" ? formData.alcoholUseDetails || "" : "",
      recreationalDrugUse: formData.recreationalDrugUse || "",
      occupation: formData.occupation || "",
      maritalStatus: formData.maritalStatus || "",
      reasonForVisit: formData.reasonForVisit || "",
      otherDisease: formData.otherDisease || "",
      pastsurgries: formData.pastsurgries || "",
      hospitalization: formData.hospitalization || "",
      pastMedication: formData.pastMedication || "",
      signature: formData.signature || "",
      hospitalizations: formData.hospitalizations || "",
      medications: formData.medications || "",
      pastSurgeries: formData.pastSurgeries || "",
      otherMedicalCondition: formData.otherMedicalCondition || "",
      diabetes: formData.diabetes === "Yes",
      highBloodPressure: formData.highBloodPressure === "Yes",
      heartDisease: formData.heartDisease === "Yes",
      asthmaCOPD: formData.asthmaCOPD === "Yes",
      kidneyDisease: formData.kidneyDisease === "Yes",
      liverDisease: formData.liverDisease === "Yes",
      cancer: formData.cancer === "Yes",
      cancerType: formData.cancer === "Yes" ? formData.cancerType || "" : "",
      sleepApnea: formData.sleepApnea === "Yes",
      depressionAnxiety: formData.depressionAnxiety === "Yes",
      noKnownAllergies: formData.noKnownAllergies === "Yes",
      medicationAllergies: formData.medicationAllergies === "Yes",
      medicationAllergiesText:
        formData.medicationAllergies === "Yes"
          ? formData.medicationAllergiesText || ""
          : "",
      foodAllergies: formData.foodAllergies === "Yes",
      foodAllergiesText:
        formData.foodAllergies === "Yes"
          ? formData.foodAllergiesText || ""
          : "",
      otherAllergies: formData.otherAllergies === "Yes",
      otherAllergiesText:
        formData.otherAllergies === "Yes"
          ? formData.otherAllergiesText || ""
          : "",
      familyHeartDisease: formData.familyHeartDisease === "Yes",
      familyHeartDiseaseRelation:
        formData.familyHeartDisease === "Yes"
          ? formData.familyHeartDiseaseRelation || ""
          : "",
      familyHighBloodPressure: formData.familyHighBloodPressure === "Yes",
      familyHighBPRelation:
        formData.familyHighBloodPressure === "Yes"
          ? formData.familyHighBPRelation || ""
          : "",
      familyStroke: formData.familyStroke === "Yes",
      familyStrokeRelation:
        formData.familyStroke === "Yes"
          ? formData.familyStrokeRelation || ""
          : "",
      familyDiabetes: formData.familyDiabetes === "Yes",
      familyDiabetesRelation:
        formData.familyDiabetes === "Yes"
          ? formData.familyDiabetesRelation || ""
          : "",
      familyCancer: formData.familyCancer === "Yes",
      familyCancerRelation:
        formData.familyCancer === "Yes"
          ? formData.familyCancerRelation || ""
          : "",
      familyCancerType:
        formData.familyCancer === "Yes" ? formData.familyCancerType || "" : "",
      familyOtherHistory: formData.familyOtherHistory === "Yes",
      familyOtherRelation:
        formData.familyOtherHistory === "Yes"
          ? formData.familyOtherRelation || ""
          : "",
      fatigue: formData.fatigue === "Yes",
      chestPain: formData.chestPain === "Yes",
      shortnessOfBreath: formData.shortnessOfBreath === "Yes",
      frequentUrination: formData.frequentUrination === "Yes",
      visionChanges: formData.visionChanges === "Yes",
      hearingProblems: formData.hearingProblems === "Yes",
      abdominalPain: formData.abdominalPain === "Yes",
      jointPain: formData.jointPain === "Yes",
      skinRashes: formData.skinRashes === "Yes",
      headaches: formData.headaches === "Yes",
      troubleSleeping: formData.troubleSleeping === "Yes",
      anxietyDepression: formData.anxietyDepression === "Yes",
      otherSymptoms: formData.otherSymptoms === "Yes",
      otherSymptomsText:
        formData.otherSymptoms === "Yes"
          ? formData.otherSymptomsText || ""
          : "",
    };

    // Clean up empty strings and null values (excluding booleans)
    Object.keys(payload).forEach((key) => {
      if (payload[key] === "" || payload[key] === null) {
        if (typeof payload[key] !== "boolean") {
          delete payload[key];
        }
      }
    });

    // If payload is empty (except for required fields), show warning
    const nonEmptyFields = Object.keys(payload).filter(
      (key) =>
        typeof payload[key] === "boolean" ||
        (payload[key] && payload[key] !== "")
    );
    if (nonEmptyFields.length <= 3) {
      // Adjust threshold based on required fields
      Swal.fire({
        icon: "warning",
        title: "No Data Provided",
        text: "Please fill out at least some fields before submitting.",
        showConfirmButton: true,
        willOpen: (popup) => {
          // Popup modal z-index
          popup.style.zIndex = "1800";
          // Overlay container z-index
          const container = document.querySelector(".swal2-container");
          if (container) container.style.zIndex = "1800";
        },
      });
      setLoading(false);
      return;
    }

    axios
      .post(
        `${process.env.REACT_APP_API_URL}/PatientQuestionnaire/AddQUESTIONARE`,
        payload,
        { headers }
      )
      .then((res) => {
       
        Swal.fire({
          icon: "success",
          title: "Record saved successfully!",
          showConfirmButton: false,
          timer: 1500,
          willOpen: (popup) => {
            // Popup modal z-index
            popup.style.zIndex = "1800";
            // Overlay container z-index
            const container = document.querySelector(".swal2-container");
            if (container) container.style.zIndex = "1800";
          },
        });
         if (onFormSubmit) {
          onFormSubmit(res.id);
        }

        if (handleClose) {
          handleClose();
        }
      })
      .catch((err) => {
        console.error("Submit error:", err.response?.data || err);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `Failed to save questionnaire: ${
            err.response?.data?.title || "Please try again."
          }`,
          showConfirmButton: true,
          willOpen: (popup) => {
            // Popup modal z-index
            popup.style.zIndex = "1800";
            // Overlay container z-index
            const container = document.querySelector(".swal2-container");
            if (container) container.style.zIndex = "1800";
          },
        });
      })
      .finally(() => setLoading(false));
  };
  const [rows, setRows] = useState([]);
  const [refresh, setRefresh] = useState(false);

  // useEffect(() => {
  //   const loadData = async () => {
  //     setLoading(true);

  //     try {
  //       const res = await axios.get(
  //         `${process.env.REACT_APP_API_URL}/PatientQuestionnaire/getListquestionarebypatientid?id=${patientId}`,
  //         { headers }
  //       );
  //       setRows(res);
  //       setLoading(false);
  //     } catch (error) {
  //       console.error("API Error:", error);
  //       setLoading(false);
  //     }
  //   };

  //   loadData();
  // }, [refresh, patientId, Patientinfo]);

  const columns = [
    {
      field: "select",
      headerName: "Select",
      sortable: false,
      width: 80,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => (
        <Tooltip title="Select to View questionnaire details">
          <Checkbox
            color="primary"
            checked={SelectedQuestionare === params.row.id}
            onClick={() => setSelectedQuestionare(params.row.id)}
          />
        </Tooltip>
      ),
    },

    {
      field: "id",
      headerName: "ID",
      headerClassName: "super-app-theme--header",
      flex: 0.1,
    },
    {
      field: "fullName",
      headerName: "Patient Name",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      flex: 0.2,
    },
    {
      field: "last Worked",
      headerName: "Created By",
      headerClassName: "super-app-theme--header",
      flex: 0.25,
      renderCell: (params) => (
        <span>
          {params.row.createdBy && params.row.createdBy.trim() !== ""
            ? params.row.createdBy
            : params.row.updatedBy || "N/A"}
        </span>
      ),
    },

    {
      field: "sendToPortal",
      headerName: "Send To Portal",
      headerClassName: "super-app-theme--header",
      flex: 0.2,
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          {params.row.sendToPortal ? (
            <CheckCircleIcon style={{ color: "green" }} />
          ) : (
            <CancelIcon style={{ color: "red" }} />
          )}
        </div>
      ),
    },
    {
      field: "Send",
      headerClassName: "super-app-theme--header",
      headerName: "Send",
      flex: 0.1,
      renderCell: (params) => (
        <Button
          variant="contained"
          size="small"
          startIcon={<SendIcon />}
          sx={{
            width: "170px", // uniform width
            background: !params.row.sendToPortal
              ? "#4CAF50" // green for reset password
              : "#2196F3", // blue for invite
            color: "#fff",
            borderRadius: "20px",
            fontWeight: 300,
            fontSize: "0.55rem",
            textTransform: "none",
            transition: "all 0.25s ease",
          }}
          disabled={params.row.sendToPortal}
          onClick={() => {
            const postData = {
              id: params.row.id,
              fullName: params.row.fullName,
              patientId: params.row.patientId,
              sendToPortal: true,
              inactive: false,
            };
            axios
              .post(
                `${process.env.REACT_APP_API_URL}/PatientQuestionnaire/AddQUESTIONARE`,
                postData,
                { headers }
              )
              .then(() => {
                Swal.fire({
                  icon: "success",
                  title: "Sent!",
                  text: "Questionnaire sent to portal successfully.",
                  confirmButtonColor: "#2196F3",
                });
                setRefresh((prev) => !prev);
              })
              .catch((err) => {
                console.error(err);
                Swal.fire({
                  icon: "error",
                  title: "Error",
                  text: "Failed to send to portal.",
                });
              });
          }}
        >
          {!params.row.sendToPortal ? "SEND" : "SENT"}
        </Button>
      ),
    },
    {
      field: "inactive",
      headerClassName: "super-app-theme--header",
      headerName: "Delete",
      flex: 0.1,
      renderCell: (params) => (
        <DeleteIcon
          style={{
            marginRight: "5px",
            float: "right",
            marginTop: "5px",
            color: "red",
            cursor: "pointer",
          }}
          onClick={() => {
            Swal.fire({
              title: "Are you sure?",
              text: "Do you want to delete this record?",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#d33",
              cancelButtonColor: "#3085d6",
              confirmButtonText: "Yes, Delete",
              cancelButtonText: "No",
              willOpen: () => {
                const swalPopup = document.querySelector(".swal2-container");
                if (swalPopup) swalPopup.style.zIndex = 2200;
              },
            }).then((result) => {
              if (result.isConfirmed) {
                const postData = {
                  id: params.row.id,
                  inactive: true,
                };

                axios
                  .post(
                    `${process.env.REACT_APP_API_URL}/PatientQuestionnaire/AddQUESTIONARE`,
                    postData,
                    { headers }
                  )
                  .then(() => {
                    Swal.fire({
                      icon: "success",
                      title: "Deleted!",
                      text: "Record deleted successfully.",
                      confirmButtonColor: "#2196F3",
                      willOpen: () => {
                        const swalPopup =
                          document.querySelector(".swal2-container");
                        if (swalPopup) swalPopup.style.zIndex = 2200;
                      },
                    });

                    setRefresh((prev) => !prev);
                  })
                  .catch((error) => {
                    console.error("Error deleting record:", error);
                    Swal.fire({
                      icon: "error",
                      title: "Error",
                      text: "There was an error while deleting the record.",
                    });
                  });
              }
            });
          }}
        />
      ),
    },
  ];
  const gridRowStyle = {
    boxShadow: 2,
    border: 2,
    borderRadius: 2,
    minHeight: "5px !important",
    background: "drak",
    fontSize: "13.4px !important",
    color: "drak !important",
    borderColor: "#326C1D",
    "& .MuiDataGrid-cell:hover": {
      color: "rgba(5, 152, 236, 0.637) !important",
      fontSize: "14.6px !important",
    },
    "&.MuiDataGrid-root .custom-column-header .MuiDataGrid-colCellTitle": {
      lineHeight: "20px !important", // Adjust this value to decrease the header height
    },
    "& .super-app-theme--header": {
      backgroundColor: "#377562",
      borderRadius: 0.1,
      color: "white",
      fontSize: "16px !important",
    },
  };
  const gridClasses = {
    columnHeader: "MuiDataGrid-columnHeaders",
  };
  const HandleAdd = async () => {
    const postData = {
      id: 0,
      fullName: OtherPatientInfo?.patientName,
      patientId: patientId,
      sendToPortal: false,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/PatientQuestionnaire/AddQUESTIONARE`,
        postData,
        { headers }
      );

      Swal.fire({
        icon: "success",
        title: "Questionnaire Added!",
        html: `<p>This questionnaire has been successfully added to the patient portal.</p>`,
        confirmButtonColor: "#2196F3",
        willOpen: () => {
          const swalPopup = document.querySelector(".swal2-container");
          if (swalPopup) swalPopup.style.zIndex = 2200;
        },
      });

      setRefresh((prev) => !prev); // refresh grid
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Failed!",
        html: `<p>${
          error.response?.data?.message ||
          "Something went wrong. Please try again."
        }</p>`,
        confirmButtonColor: "#F44336",
        willOpen: () => {
          const swalPopup = document.querySelector(".swal2-container");
          if (swalPopup) swalPopup.style.zIndex = 2200;
        },
      });
    }
  };

  return (
    <>
      {/* <div style={{ width: "100%", maxWidth: "98%", margin: "30px auto" }}>
        <Accordion
          style={{
            width: "100%",
            marginBottom: "10px",
            border: "1px solid #347310",
            borderRadius: "10px",
            marginTop: "10px",
            marginLeft: "5px",
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between", // IMPORTANT
              width: "100%",
            }}
          >
            <Typography variant="h5" gutterBottom sx={{ color: "#45535cff" }}>
              Patient Questionnaires
            </Typography>
          </AccordionSummary>

          <AccordionDetails>
            <Button
              variant="contained"
              onClick={HandleAdd}
              sx={{
                borderRadius: "22px",
                padding: "8px 24px",
                textTransform: "none",
                fontWeight: 600,
                background: "linear-gradient(45deg, #326C1D, #377562)",
                "&:hover": {
                  background: "linear-gradient(45deg, #204413ff, #81e6c8ff)",
                },
              }}
            >
              Add New Questionnaires
            </Button>
            <Box mb={3} marginTop={2}>
              {loading ? (
                <div style={{ margin: "5rem", textAlign: "center" }}>
                  <CircularProgress />
                </div>
              ) : (
                <Box sx={{ height: 300, overflowY: "auto" }}>
                  {rows === null || rows.length === 0 ? (
                    <Typography>No Questionnaires Found </Typography>
                  ) : (
                    <DataGrid
                      rows={rows}
                      columns={columns}
                      classes={gridClasses}
                      sx={gridRowStyle}
                      pagination
                      pageSizeOptions={[25]}
                      initialState={{
                        pagination: {
                          paginationModel: { pageSize: 25, page: 0 },
                        },
                      }}
                      rowHeight={30}
                    />
                  )}
                </Box>
              )}
            </Box>
          </AccordionDetails>
        </Accordion>
      </div> */}
      <Box sx={{ m: 3 }}>
        {loading && (
          <CircularProgress sx={{ display: "block", mx: "auto", my: 2 }} />
        )}
        <form onSubmit={onSubmit}>
          <Box
            sx={{
              backgroundColor: "#F9FEFF",
              p: 3,
              borderRadius: 2,
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            }}
          >
            <Typography variant="h5" gutterBottom sx={{ color: "#87CEFA" }}>
              Patient Information
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Typography variant="body2" sx={{ mb: 0.5 }}>
                  First Name
                </Typography>
                <TextField
                  size="small"
                  fullWidth
                  name="fullName"
                  value={PatientFirstname}
                  InputProps={{ readOnly: true }}
                  InputLabelProps={{ shrink: true }}
                  required
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body2" sx={{ mb: 0.5 }}>
                  Last Name
                </Typography>
                <TextField
                  size="small"
                  fullWidth
                  name="lastName"
                  value={PatientLastName}
                  InputProps={{ readOnly: true }}
                  InputLabelProps={{ shrink: true }}
                  required
                />
              </Grid>
              <Grid item xs={12} md={6} container spacing={2}>
                <Grid item xs={6}>
                  <Typography variant="body2" sx={{ mb: 0.5 }}>
                    Date of Birth
                  </Typography>
                  <TextField
                    size="small"
                    fullWidth
                    type="date"
                    name="dob"
                    value={PatientDob || ""}
                    InputProps={{ readOnly: true }}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body2" sx={{ mb: 0.5 }}>
                    Age
                  </Typography>
                  <TextField
                    size="small"
                    fullWidth
                    name="age"
                    value={PatientAge}
                    InputProps={{ readOnly: true }}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body2" sx={{ mb: 0.5 }}>
                  Phone Number
                </Typography>
                <InputMask
                  mask="(999) 999-9999"
                  value={PatientcellPhone}
                  onChange={handleChange}
                >
                  {(inputProps) => (
                    <TextField
                      {...inputProps}
                      size="small"
                      fullWidth
                      name="phone"
                    />
                  )}
                </InputMask>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body2" sx={{ mb: 0.5 }}>
                  Email
                </Typography>
                <TextField
                  size="small"
                  fullWidth
                  name="email"
                  value={PatientemailAddress}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body2" sx={{ mb: 0.5 }}>
                  Gender
                </Typography>
                <RadioGroup
                  name="gender"
                  value={PatientGender}
                  onClick={handleChangeRadio}
                  row
                >
                  <FormControlLabel
                    value="Male"
                    control={<Radio size="small" />}
                    label="Male"
                  />
                  <FormControlLabel
                    value="Female"
                    control={<Radio size="small" />}
                    label="Female"
                  />
                  <FormControlLabel
                    value="Other"
                    control={<Radio size="small" />}
                    label="Other"
                  />
                </RadioGroup>
                {formData.gender === "Other" && (
                  <>
                    <Typography variant="body2" sx={{ mb: 0.5, mt: 1 }}>
                      Please specify
                    </Typography>
                    <TextField
                      size="small"
                      fullWidth
                      name="otherGender"
                      value={formData.otherGender || ""}
                      onChange={handleChange}
                    />
                  </>
                )}
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body2" sx={{ mb: 0.5 }}>
                  Address
                </Typography>
                <TextField
                  size="small"
                  fullWidth
                  name="address"
                  value={Patientaddress}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body2" sx={{ mb: 0.5 }}>
                  Emergency Contact Name / Phone
                </Typography>
                <TextField
                  size="small"
                  fullWidth
                  name="emergencyContact"
                  value={formData.emergencyContact || ""}
                  onChange={handleChange}
                />
              </Grid>
            </Grid>
          </Box>

          {/* Insurance Information */}
          <Box
            sx={{
              backgroundColor: "#ffffff",
              p: 3,
              borderRadius: 2,
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              mt: 3,
            }}
          >
            <Typography variant="h5" gutterBottom sx={{ color: "#34495e" }}>
              Insurance Information
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Typography variant="body2" sx={{ mb: 0.5 }}>
                  Primary Insurance Carrier
                </Typography>
                <TextField
                  size="small"
                  fullWidth
                  name="primaryInsuranceCarrier"
                  value={InsuranceplanName}
                  disabled={InsurancesubsRelation === "Self"}
                  onChange={handleInsuranceChange}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body2" sx={{ mb: 0.5 }}>
                  Policy / Member ID #
                </Typography>
                <TextField
                  size="small"
                  fullWidth
                  name="policyNumber"
                  value={InsurancememberId}
                  disabled={InsurancesubsRelation === "Self"}
                  onChange={handleInsuranceChange}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body2" sx={{ mb: 0.5 }}>
                  Group #
                </Typography>
                <TextField
                  size="small"
                  fullWidth
                  name="groupNumber"
                  disabled={InsurancesubsRelation === "Self"}
                  value={InsurancegroupId}
                  onChange={handleInsuranceChange}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body2" sx={{ mb: 0.5 }}>
                  Policyholder's Name
                </Typography>
                <TextField
                  size="small"
                  fullWidth
                  name="policyHolderName"
                  disabled={InsurancesubsRelation === "Self"}
                  value={PolicyHolderName}
                  onChange={handleInsuranceChange}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body2" sx={{ mb: 0.5 }}>
                  Policyholder's Date of Birth
                </Typography>
                <TextField
                  size="small"
                  fullWidth
                  type="date"
                  name="policyHolderDOB"
                  //  value={InsuranceDOB}
                  disabled={InsurancesubsRelation === "Self"}
                  value={PolicyHolderDOB}
                  onChange={handleInsuranceChange}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body2" sx={{ mb: 0.5 }}>
                  Relationship to Patient
                </Typography>
                <RadioGroup
                  name="relationshipToPatient"
                  value={InsurancesubsRelation}
                  subsRelation
                  onClick={handleInsuranceChange}
                  row
                >
                  <FormControlLabel
                    value="Self"
                    control={<Radio size="small" />}
                    label="Self"
                  />
                  <FormControlLabel
                    value="Spouse"
                    control={<Radio size="small" />}
                    label="Spouse"
                  />
                  <FormControlLabel
                    value="Mother"
                    control={<Radio size="small" />}
                    label="Mother"
                  />
                  <FormControlLabel
                    value="Father"
                    control={<Radio size="small" />}
                    label="Father"
                  />
                  <FormControlLabel
                    value="Other"
                    control={<Radio size="small" />}
                    label="Other"
                  />
                </RadioGroup>
                {formData.relationshipToPatient === "Other" && (
                  <>
                    <Typography variant="body2" sx={{ mb: 0.5, mt: 1 }}>
                      Please specify
                    </Typography>
                    <TextField
                      size="small"
                      fullWidth
                      name="otherRelationship"
                      value={formData.otherRelationship || ""}
                      onChange={handleInsuranceChange}
                    />
                  </>
                )}
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body2" sx={{ mb: 0.5 }}>
                  Insurance Phone Number (from card)
                </Typography>
                <TextField
                  size="small"
                  fullWidth
                  name="insurancePhone"
                  disabled={InsurancesubsRelation === "Self"}
                  value={InsurancePhone}
                  onChange={handleInsuranceChange}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body2" sx={{ mb: 0.5 }}>
                  Secondary Insurance (if applicable)
                </Typography>
                <TextField
                  size="small"
                  fullWidth
                  name="secondaryInsurance"
                  disabled={InsurancesubsRelation === "Self"}
                  value={SecInsuranceplanName || ""}
                  onChange={handleInsuranceChange}
                />
              </Grid>
            </Grid>
          </Box>

          {/* Medical History */}
          <Box
            sx={{
              backgroundColor: "#ffffff",
              p: 3,
              borderRadius: 2,
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              mt: 3,
            }}
          >
            <Typography variant="h5" gutterBottom sx={{ color: "#34495e" }}>
              Medical History
            </Typography>
            <FormGroup>
              <Typography sx={{ mb: 2, fontWeight: 600 }}>
                1. Do you have (select all that apply):
              </Typography>
              <Grid container spacing={2} sx={{ mb: 3 }}>
                {[
                  { name: "diabetes", label: "Diabetes" },
                  { name: "highBloodPressure", label: "High Blood Pressure" },
                  { name: "heartDisease", label: "Heart Disease" },
                  { name: "asthmaCOPD", label: "Asthma/COPD" },
                  { name: "kidneyDisease", label: "Kidney Disease" },
                  { name: "liverDisease", label: "Liver Disease" },
                  { name: "cancer", label: "Cancer", extraField: "cancerType" },
                  { name: "sleepApnea", label: "Sleep Apnea" },
                  { name: "depressionAnxiety", label: "Depression/Anxiety" },
                ].map((item) => (
                  <Grid item xs={12} sm={6} md={4} key={item.name}>
                    <Typography variant="body2" sx={{ mb: 0.5 }}>
                      {item.label}
                    </Typography>
                    <RadioGroup
                      name={item.name}
                      value={formData[item.name] || ""}
                      onClick={handleChangeRadio}
                      row
                    >
                      <FormControlLabel
                        value="Yes"
                        control={<Radio size="small" />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value="No"
                        control={<Radio size="small" />}
                        label="No"
                      />
                    </RadioGroup>
                    {item.extraField && formData[item.name] === "Yes" && (
                      <TextField
                        size="small"
                        label="Specify"
                        name={item.extraField}
                        value={formData[item.extraField] || ""}
                        onChange={handleChange}
                        fullWidth
                        sx={{ mt: 1 }}
                      />
                    )}
                  </Grid>
                ))}
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <Typography sx={{ mb: 2, fontWeight: 600 }}>
                  Other Disease
                </Typography>
                <TextField
                  size="small"
                  fullWidth
                  name="otherDisease"
                  value={formData.otherDisease || ""}
                  onChange={handleChange}
                  multiline
                  minRows={2} // default height
                  sx={{
                    mb: 2,
                    "& .MuiInputBase-input": {
                      resize: "vertical", // 👈 sirf height change hogi
                      overflow: "auto",
                    },
                  }}
                />
              </Grid>
             <Grid item xs={12} sm={12} md={12}>
                <Typography sx={{ mb: 2, fontWeight: 600 }}>
                  Past Surgeries
                </Typography>
                <TextField
                  size="small"
                  fullWidth
                  name="pastsurgries"
                  value={formData.pastsurgries || ""}
                  onChange={handleChange}
                  multiline
                  minRows={2} // default height
                  sx={{
                    mb: 2,
                    "& .MuiInputBase-input": {
                      resize: "vertical", // 👈 sirf height change hogi
                      overflow: "auto",
                    },
                  }}
                />
              </Grid>
             <Grid item xs={12} sm={12} md={12}>
                <Typography sx={{ fontWeight: 600 }}>
                  Hospitalization (Last 5 Years):
                </Typography>
                <TextField
                  size="small"
                  fullWidth
                  name="hospitalization"
                  value={formData.hospitalization || ""}
                  onChange={handleChange}
                  multiline
                  minRows={2} // default height
                  sx={{
                    mb: 2,
                    "& .MuiInputBase-input": {
                      resize: "vertical", // 👈 sirf height change hogi
                      overflow: "auto",
                    },
                  }}
                />
              </Grid>

               <Grid item xs={12} sm={12} md={12}>
                <Typography sx={{ fontWeight: 600 }}>Medication</Typography>
                <Typography sx={{ mb: 2, fontWeight: 300 }}>
                  Please all Prescrition and over the counter medication include
                  vitamins suppleme
                </Typography>
                <TextField
                  size="small"
                  fullWidth
                  name="pastMedication"
                  value={formData.pastMedication || ""}
                  onChange={handleChange}
                  multiline
                  minRows={2} // default height
                  sx={{
                    mb: 2,
                    "& .MuiInputBase-input": {
                      resize: "vertical", // 👈 sirf height change hogi
                      overflow: "auto",
                    },
                  }}
                />
              </Grid>
            </FormGroup>
          </Box>

          {/* Allergies */}
          <Box
            sx={{
              backgroundColor: "#ffffff",
              p: 3,
              borderRadius: 2,
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              mt: 3,
            }}
          >
            <Typography variant="h5" gutterBottom sx={{ color: "#34495e" }}>
              Allergies
            </Typography>
            <FormGroup>
              <Grid container spacing={2}>
                {[
                  { name: "noKnownAllergies", label: "No known allergies" },
                  {
                    name: "medicationAllergies",
                    label: "Medication Allergies",
                    extraField: "medicationAllergiesText",
                  },
                  {
                    name: "foodAllergies",
                    label: "Food/Environmental Allergies",
                    extraField: "foodAllergiesText",
                  },
                  {
                    name: "otherAllergies",
                    label: "Other Allergies",
                    extraField: "otherAllergiesText",
                  },
                ].map((item) => (
                  <Grid item xs={12} sm={6} md={4} key={item.name}>
                    <Typography variant="body2" sx={{ mb: 0.5 }}>
                      {item.label}
                    </Typography>
                    <RadioGroup
                      name={item.name}
                      value={formData[item.name] || ""}
                      onClick={handleChangeRadio}
                      row
                    >
                      <FormControlLabel
                        value="Yes"
                        control={<Radio size="small" />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value="No"
                        control={<Radio size="small" />}
                        label="No"
                      />
                    </RadioGroup>
                    {item.extraField && formData[item.name] === "Yes" && (
                      <TextField
                        size="small"
                        label="Specify"
                        name={item.extraField}
                        value={formData[item.extraField] || ""}
                        onChange={handleChange}
                        fullWidth
                        sx={{ mt: 1 }}
                      />
                    )}
                  </Grid>
                ))}
              </Grid>
            </FormGroup>
          </Box>

          {/* Family History */}
          <Box
            sx={{
              backgroundColor: "#ffffff",
              p: 3,
              borderRadius: 2,
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              mt: 3,
            }}
          >
            <Typography variant="h5" gutterBottom sx={{ color: "#34495e" }}>
              Family History
            </Typography>
            <FormGroup>
              <Typography sx={{ mb: 2, fontWeight: 500 }}>
                Family History (select all that apply and list relationship)
              </Typography>
              <Grid container spacing={2}>
                {[
                  {
                    name: "familyHeartDisease",
                    label: "Heart Disease",
                    relation: "familyHeartDiseaseRelation",
                  },
                  {
                    name: "familyHighBloodPressure",
                    label: "High Blood Pressure",
                    relation: "familyHighBPRelation",
                  },
                  {
                    name: "familyStroke",
                    label: "Stroke",
                    relation: "familyStrokeRelation",
                  },
                  {
                    name: "familyDiabetes",
                    label: "Diabetes",
                    relation: "familyDiabetesRelation",
                  },
                  {
                    name: "familyCancer",
                    label: "Cancer",
                    relation: "familyCancerRelation",
                    extraField: "familyCancerType",
                  },
                  {
                    name: "familyOtherHistory",
                    label: "Other",
                    relation: "familyOtherRelation",
                  },
                ].map((item) => (
                  <Grid item xs={12} key={item.name}>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      {item.label}
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={3}>
                        <RadioGroup
                          name={item.name}
                          value={formData[item.name] || ""}
                          onClick={handleChangeRadio}
                          row
                        >
                          <FormControlLabel
                            value="Yes"
                            control={<Radio size="small" />}
                            label="Yes"
                          />
                          <FormControlLabel
                            value="No"
                            control={<Radio size="small" />}
                            label="No"
                          />
                        </RadioGroup>
                      </Grid>
                      {formData[item.name] === "Yes" && (
                        <Grid item xs={9}>
                          <Box
                            sx={{
                              display: "flex",
                              gap: 1,
                              alignItems: "center",
                            }}
                          >
                            {item.extraField && (
                              <TextField
                                size="small"
                                label="Type"
                                name={item.extraField}
                                value={formData[item.extraField] || ""}
                                onChange={handleChange}
                                sx={{ width: "30%" }}
                              />
                            )}
                            <Typography sx={{ whiteSpace: "nowrap" }}>
                              Relationship
                            </Typography>
                            <TextField
                              size="small"
                              name={item.relation}
                              value={formData[item.relation] || ""}
                              onChange={handleChange}
                              sx={{ flex: 1 }}
                            />
                          </Box>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            </FormGroup>
          </Box>

          {/* Social History */}
          <Box
            sx={{
              backgroundColor: "#ffffff",
              p: 3,
              borderRadius: 2,
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              mt: 3,
            }}
          >
            <Typography variant="h5" gutterBottom sx={{ color: "#34495e" }}>
              Social History
            </Typography>
            <Typography variant="body2" sx={{ mb: 0.5 }}>
              Tobacco Use
            </Typography>
            <RadioGroup
              name="tobaccoUse"
              value={formData.tobaccoUse || ""}
              onClick={handleChangeRadio}
              row
              sx={{ mb: 2 }}
            >
              <FormControlLabel
                value="Current"
                control={<Radio size="small" />}
                label="Current"
              />
              <FormControlLabel
                value="Former"
                control={<Radio size="small" />}
                label="Former"
              />
              <FormControlLabel
                value="Never"
                control={<Radio size="small" />}
                label="Never"
              />
            </RadioGroup>
            <Typography variant="body2" sx={{ mb: 0.5 }}>
              Alcohol Use
            </Typography>
            <RadioGroup
              name="alcoholUse"
              value={formData.alcoholUse || ""}
              onClick={handleChangeRadio}
              row
              sx={{ mb: 1 }}
            >
              <FormControlLabel
                value="Yes"
                control={<Radio size="small" />}
                label="Yes"
              />
              <FormControlLabel
                value="No"
                control={<Radio size="small" />}
                label="No"
              />
            </RadioGroup>
            {formData.alcoholUse === "Yes" && (
              <TextField
                size="small"
                label="How often"
                name="alcoholUseDetails"
                value={formData.alcoholUseDetails || ""}
                onChange={handleChange}
                sx={{ mb: 2, width: { xs: "100%", sm: "50%" } }}
              />
            )}
            <Typography variant="body2" sx={{ mb: 0.5 }}>
              Recreational Drug Use
            </Typography>
            <RadioGroup
              name="recreationalDrugUse"
              value={formData.recreationalDrugUse || ""}
              onClick={handleChangeRadio}
              row
              sx={{ mb: 2 }}
            >
              <FormControlLabel
                value="Yes"
                control={<Radio size="small" />}
                label="Yes"
              />
              <FormControlLabel
                value="No"
                control={<Radio size="small" />}
                label="No"
              />
            </RadioGroup>
            <Typography variant="body2" sx={{ mb: 2, fontWeight: 600 }}>
              Occupation
            </Typography>
            <TextField
              size="small"
              fullWidth
              name="occupation"
              value={formData.occupation || ""}
              onChange={handleChange}
              sx={{ mb: 2 }}
            />
            <Typography variant="body2" sx={{ mb: 0.5 }}>
              Marital Status
            </Typography>
            <RadioGroup
              name="maritalStatus"
              value={formData.maritalStatus || ""}
              onClick={handleChangeRadio}
              row
            >
              <FormControlLabel
                value="Single"
                control={<Radio size="small" />}
                label="Single"
              />
              <FormControlLabel
                value="Married"
                control={<Radio size="small" />}
                label="Married"
              />
              <FormControlLabel
                value="Divorced"
                control={<Radio size="small" />}
                label="Divorced"
              />
              <FormControlLabel
                value="Widowed"
                control={<Radio size="small" />}
                label="Widowed"
              />
            </RadioGroup>
          </Box>

          {/* Symptoms */}
          <Box
            sx={{
              backgroundColor: "#ffffff",
              p: 3,
              borderRadius: 2,
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              mt: 3,
            }}
          >
            <Typography variant="h5" gutterBottom sx={{ color: "#34495e" }}>
              Symptoms Checklist
            </Typography>
            <FormGroup>
              <Grid container spacing={2}>
                {[
                  { name: "fatigue", label: "Fatigue/low energy" },
                  { name: "chestPain", label: "Chest pain/palpitations" },
                  { name: "shortnessOfBreath", label: "Shortness of breath" },
                  { name: "frequentUrination", label: "Frequent urination" },
                  { name: "visionChanges", label: "Vision changes" },
                  { name: "hearingProblems", label: "Hearing problems" },
                  { name: "abdominalPain", label: "Abdominal pain" },
                  { name: "jointPain", label: "Joint pain/stiffness" },
                  { name: "skinRashes", label: "Skin rashes/changes" },
                  { name: "headaches", label: "Headaches/dizziness" },
                  { name: "troubleSleeping", label: "Trouble sleeping" },
                  { name: "anxietyDepression", label: "Anxiety/depression" },
                  { name: "otherSymptoms", label: "Other" },
                ].map((item) => (
                  <Grid item xs={12} sm={6} md={4} key={item.name}>
                    <Typography variant="body2" sx={{ mb: 0.5 }}>
                      {item.label}
                    </Typography>
                    <RadioGroup
                      name={item.name}
                      value={formData[item.name] || ""}
                      onClick={handleChangeRadio}
                      row
                    >
                      <FormControlLabel
                        value="Yes"
                        control={<Radio size="small" />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value="No"
                        control={<Radio size="small" />}
                        label="No"
                      />
                    </RadioGroup>
                    {item.name === "otherSymptoms" &&
                      formData.otherSymptoms === "Yes" && (
                        <TextField
                          size="small"
                          label="Specify"
                          name="otherSymptomsText"
                          value={formData.otherSymptomsText || ""}
                          onChange={handleChange}
                          fullWidth
                          sx={{ mt: 1 }}
                        />
                      )}
                  </Grid>
                ))}
              </Grid>
            </FormGroup>
          </Box>

          {/* Reason for Visit */}
          <Box
            sx={{
              backgroundColor: "#ffffff",
              p: 3,
              borderRadius: 2,
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              mt: 3,
            }}
          >
            <Typography variant="h5" gutterBottom sx={{ color: "#34495e" }}>
              Reason for Today's Visit
            </Typography>
            <Typography variant="body2" sx={{ mb: 0.5 }}>
              Reason
            </Typography>
            <TextField
              size="small"
              fullWidth
              name="reasonForVisit"
              value={formData.reasonForVisit || ""}
              onChange={handleChange}
              required
            />
          </Box>

          {/* Patient Acknowledgment */}
          <Box
            sx={{
              backgroundColor: "#ffffff",
              p: 3,
              borderRadius: 2,
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              mt: 3,
            }}
          >
            <Typography variant="h5" gutterBottom sx={{ color: "#34495e" }}>
              Patient Acknowledgment
            </Typography>
            <Typography sx={{ mb: 3 }}>
              I certify that the above information is true and complete to the
              best of my knowledge.
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography variant="body2" sx={{ mb: 0.5 }}>
                  Signature
                </Typography>
                <TextField
                  size="small"
                  fullWidth
                  name="signature"
                  value={formData.signature || ""}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography variant="body2" sx={{ mb: 0.5 }}>
                  Date
                </Typography>
                <TextField
                  size="small"
                  fullWidth
                  type="date"
                  name="date"
                  value={PatientDate}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (moment(value, "YYYY-MM-DD", true).isValid()) {
                      setPatientDate(value);
                    }
                  }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Box>

          {/* Submit and Cancel */}
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", mt: 3, gap: 2 }}
          >
            <Button
              variant="outlined"
              onClick={handleClose}
              startIcon={<CancelIcon />}
              sx={{
                textTransform: "none",
                color: "white",
                background: "linear-gradient(to right, #165baaff, #6EB5FF)",
                borderRadius: "6px",
                paddingX: 2,
                mr: 0.5,
                paddingY: 0.8,
                fontWeight: "bold",
                "&:hover": {
                  background: "linear-gradient(to right, #3B7DD8, #5AA4F5)",
                },
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              type="submit"
              disabled={loading}
              sx={{
                textTransform: "none",
                color: "white",
                background: "linear-gradient(to right, #165baaff, #6EB5FF)",
                borderRadius: "6px",
                paddingX: 2,
                mr: 0.5,
                paddingY: 0.8,
                fontWeight: "bold",
                "&:hover": {
                  background: "linear-gradient(to right, #3B7DD8, #5AA4F5)",
                },
              }}
            >
              <SaveOutlinedIcon
                fontSize="medium"
                sx={{ color: "white", mr: 0.5 }}
              />
              Save
            </Button>
          </Box>
        </form>
      </Box>
    </>
  );
}
